import { format } from './utils';

export default function(el, binding) {
  el.oninput = function() {
    el.value = format(el.value, binding.value);
    el.dispatchEvent(new Event('change'));
  };
}
